import { Countertop } from '../countertop.class';
import { CountertopSkuAssetData } from '../data/countertop-sku-asset-data.class'

/**
 * Calculates countertop price based on material, island type and size
 * @Param countertop Countertop
 * @returns MSRP
 */
export const getCountertopMsrpCfn = (countertop: Countertop, sku: string): number => {
	const { priceBook } = countertop.context;
	if (priceBook) return priceBook.findCountertopSku(sku)?.msrp ?? 0;

	const countertopSku = CountertopSkuAssetData.findBySku(sku)
	const countertopMsrp = countertopSku ? countertopSku.msrp : 0;
	return countertopMsrp;
	// const island = countertop.refMap.kitchenDesign.islands.findById(countertop.islandIds[0]);
	// const { isGranite } = countertop.material;
	// const { displayName } = island.surround;

	// const msrpMap: CuntertopMsrpAssetMap = countertopMsrpMap;
	// const skuSizeMap = {
	// 	CORNER: 5,
	// 	ASADO: 3,
	// 	PIZZA: 3
	// };

	// const islandSkuSize = island.skuSize in skuSizeMap ? skuSizeMap[island.skuSize] : Number(island.skuSize);
	// const islandType = island.isCornerIsland
	// 	? 'CORNER'
	// 	: 'STANDARD';
	// const islandMaterial = (isGranite ? 'granite' : countertop.material.edge);

	// const msrpEntry = msrpMap.find((entry) => {
	// 	return entry.size === (Number(islandSkuSize)) &&
	// 		entry.material === (islandMaterial) &&
	// 		entry.islandType === (islandType);
	// });

	// const msrpEntryTotal = msrpEntry ? { ...msrpEntry } : { size: 0, material: '', islandType: '', msrp: 0 };
	// if (islandType !== 'CORNER' && island.overallSize.depth > 40) {
	// 	msrpEntryTotal.msrp += isGranite ? 500 : 1000;
	// }
	// // console.log('getCountertopMsrpCfn', msrpEntry, islandSkuSize, countertop.material.type, island.isCornerIsland);
	// return msrpEntryTotal?.msrp ?? 0;
};
